import { AppBar, Slide, Toolbar, useScrollTrigger } from '@material-ui/core'
import React from 'react'
import { Sizes } from 'src/lib/theming'
import styled, { css } from 'styled-components'

import ActionButton from '../menu/ActionButton'
import ActionGroup from '../menu/ActionGroup'
import { HeaderStylesProps } from '../menu/Navigation'

type HeaderType = {
  actions?: React.ReactNode | null
  logo?: React.ReactNode
  navigation?: React.ReactNode
  styles?: HeaderStylesProps
}

const HideOnScroll = ({ children }: { children: React.ReactElement }) => {
  const trigger = useScrollTrigger()
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}

const HeaderAppBar = styled(AppBar)`
  ${({ theme: { palette } }) => css`
    background-color: ${palette.primary.main};
    color: ${palette.primary.contrastText};
  `}
`

export const breakpointHeaderHeightsRem: Sizes = {
  md: 4.5,
  xs: 4,
}

const HeaderToolbar = styled(Toolbar)`
  ${({ theme: { spacing, breakpoints } }) => css`
    height: ${breakpointHeaderHeightsRem.md}rem;
    justify-content: space-between;
    min-height: auto;
    padding: ${spacing(1)}px ${spacing(2)}px;
    ${breakpoints.down('md')} {
      height: ${breakpointHeaderHeightsRem.xs}rem;
      & ${ActionButton} {
        margin-bottom: 0;
        white-space: nowrap;
        padding: ${spacing(1)}px;
      }
      & ${ActionGroup} {
        padding: 0;
        margin: ${spacing(0, 1, 0, 1)};
        width: auto;
      }
      & .MuiIconButton-root {
        padding: 0;
        margin: 0;
      }
    }
    ${breakpoints.down('md')} {
      & ${ActionButton} {
        margin-right: ${spacing(1)}px;
      }
    }
    ${breakpoints.down('sm')} {
      & ${ActionButton}:nth-of-type(1) {
        display: none;
      }
    }
  `}
`

const Header = ({ navigation, logo, styles = {}, actions }: HeaderType) => {
  return (
    <>
      <HideOnScroll>
        <HeaderAppBar
          elevation={0}
          style={{
            backgroundColor: styles.backgroundColor,
            color: styles.textColor,
            height: styles.height,
          }}
        >
          <HeaderToolbar>
            {logo}
            {actions}
            {navigation}
          </HeaderToolbar>
        </HeaderAppBar>
      </HideOnScroll>
      {styles.backgroundColor !== 'transparent' && <HeaderToolbar />}
    </>
  )
}

export default Header
